angular.module('app.controllers').controller 'ProgramsCtrl', [
  '$scope', '$rootScope', 'APIPrograms', 'Table', '$interval', 'APIForm', 'APIPolls', '$location', '$timeout', 'APIInquiries', 'UI', '$q'
].append (self, root, APIPrograms, Table, $interval, APIForm, APIPolls, $location, $timeout, APIInquiries, UI, $q) ->
  

  self.currentProgram = null

  getLiveProgram = (initYT = false, customTime = '', rework = false) ->
    return unless self.programs?.length

    # Get custom time from URL if provided
    if $location.search().test
      customTime = moment().format('HH:mm')
    else
      customTime = $location.search().time if $location.search().time && !customTime
    currentTime = moment()
    baseDate    = '2026-06-16'
  
    # If custom time provided, use it with the base date
    currentTime = moment("#{baseDate} #{customTime}") if customTime

    newCurrentProgram = self.programs.find((program) ->
      programDateStart  = program.dd.concat(" #{program.start}")
      programDateStart  = program.dd.concat(" 08:00:00") if program.id is 6199
      programDateEnd    = program.dd.concat(" #{program.end}")
      return currentTime.isBetween(programDateStart, programDateEnd, undefined, '[)') 
    ) || null

    if (newCurrentProgram != self.currentProgram)
      self.currentProgram = newCurrentProgram

    root.$broadcast('toggleHomeIntro', self.currentProgram?.description_de || null) if self.at('home')

  programsInterval = $interval getLiveProgram, 10000, 0, true, false, '', false

  self.isOffline = (slot) ->
    return slot.id != self.currentProgram?.id

  ad = ['1', '16.06.2026']
  td = moment().format('DD.MM.YYYY')
  if self.at('home') 
    self.day = 1
  else
    self.day = if td in ad then ad.indexOf(td) else 1


  self.setDay = (day) ->
    self.day = day  

  self.$watch 'day', (newObj, oldObj) ->
    return unless newObj
    return if self.programs?.length && self.at('home')
    loadDayPrograms(newObj)
  , true

  self.days = [
    {
      title: '16.06'
      title_sm: '.26'
      day: 1
      full: '2026-06-16'
    }
  ]

  loadDayPrograms = (day, add = false) ->      
    self.dataLoad = false
    APIPrograms.get {day: day, _entry: 'programs'}, (data) ->
     
      programs = data.tracks.filter((track) -> return track.visible).map((track) ->
        track.slots = track.slots.filter((slot) -> 
          return slot.visible && slot.slot_type not in ['pause', 'faq'] if self.at('home')
          return slot.visible
        ).map((slot) ->
          slot.day_int = day
          return slot
        )
        return track
      )[if self.at('home') && data.tracks.length > 1 then 1 else 0].slots

      if add
        self.programs = self.programs.concat(programs)
      else
        self.programs = programs

      if self.at('home-') && day < self.days.length
        day++
        loadDayPrograms(day, true)
      else
        getLiveProgram()
        self.dataLoad = true
      
      self.$applyAsync()

  self.openProgramModal = (data = null, id = null) ->
    root.$broadcast 'onProgramModalOpen', data, id

  self.openSpeakerModal = (data = null, id = null) ->
    root.$broadcast 'onSpeakerModalOpen', data, id

  self.v23El = document.getElementById('videoModal23')
  if self.v23El?
    self.v23 = bootstrap.Modal.getOrCreateInstance(self.v23El)

    self.v23El.addEventListener('show.bs.modal', (event) ->
      self.customStat(null, 'open_23_link', self.open23data?.title_de || self.open23data?.title_en || '')

      self.$applyAsync()
    )
    self.v23El.addEventListener('hide.bs.modal', (event) ->
      self.closeDataModal()
      self.customStat(null, 'close_23_link', self.open23data?.title_de || self.open23data?.title_en || '')
    )

  self.open23 = (slot) ->
    return unless slot?.description_de
    self.open23data = slot
    self.v23.show()
    self.showDataModal({video: slot.description_de, fair: null, variab: 'modalData23'})

  self.$on '$destroy', ->    
    if angular.isDefined(playingInterval)
      $interval.cancel(playingInterval)
      playingInterval = undefined

    if angular.isDefined(pollsInterval)
      $interval.cancel(pollsInterval)
      pollsInterval = undefined

    if angular.isDefined(programsInterval)
      $interval.cancel(programsInterval)
      programsInterval = undefined


  self.default3colsSlider2 =
    infinite: false
    arrows: false
    slidesToShow: 3
    slidesToScroll: 1
    swipeToSlide: true
    speed: 500
    autoplay: true
    autoplaySpeed: 5000
    useCSS: false
    cssEase: 'linear'
    dots: true
    dotsClass: 'slider-dots'
    method: {}
    event:
      init: (event, slick) ->
        slick.slickFilter('[pr-day="1"]')

    customPaging : (slider, i) -> 
      return false if slider.slideCount == 1 || slider.slideCount == slider.options.slidesToShow
      return "<a class='slider-dots-item'></a>"

    responsive: [
      {
        breakpoint: 1200
        settings: 
          slidesToShow: 1
          slidesToScroll: 1
          centerMode: true
          centerPadding: '40px'
          infinite: true
      }
      {
        breakpoint: 992
        settings: 
          slidesToShow: 1
          slidesToScroll: 1
          centerMode: true
          centerPadding: '24px'
          infinite: true
      }
    ]


angular.module('app.controllers').controller 'ProgramsModalCtrl', [
  '$scope', '$rootScope', 'APISlots', 'UI'
].append (self, root, APISlots, UI) ->

  self.id = null
  self.data = null

  self.programModalEl = document.getElementById('programModal')

  if self.programModalEl
    self.programModal = bootstrap.Modal.getOrCreateInstance(self.programModalEl)
  
    self.programModalEl.addEventListener('hidden.bs.modal', (event) ->
      self.id = null
      self.data = null
      self.$applyAsync()
    )

    self.programModalEl.addEventListener('show.bs.modal', (event) ->
      unless self.data
        APISlots.get {id: self.id, _entry: 'slot'}, (data) ->
          self.data = data      
        , (response) ->
          UI.notify false, response.data.error
      self.$applyAsync()
    )

  self.$on 'onProgramModalOpen', (event, data = null, id = null) ->
    self.id = id
    self.data = data
    self.programModal.show()

  self.openSpeakerModal = (data = null, id = null) ->
    root.$broadcast 'onSpeakerModalOpen', data, id, false